/* Kocktail — site-wide scroll reveal.
   Elements marked [data-kx-reveal] fade + lift into view as they enter the
   viewport (mirrors the design's IntersectionObserver reveal). Children with
   [data-kx-stagger] receive an incremental transition-delay. Respects
   prefers-reduced-motion. Safe to load on every page. */
(function () {
  function reveal(el) { el.classList.add('kx-in'); }
  var designMode = window.Shopify && Shopify.designMode;

  function revealAll() {
    document.querySelectorAll('[data-kx-reveal]').forEach(reveal);
  }

  function init() {
    // In the theme editor, scroll-reveal can leave sections blank (the observer
    // never fires for content already in view / freshly injected). Show
    // everything immediately and keep new sections visible as they're added.
    if (designMode) {
      revealAll();
      document.addEventListener('shopify:section:load', revealAll);
      return;
    }

    var nodes = document.querySelectorAll('[data-kx-reveal]');
    if (!nodes.length) return;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || typeof IntersectionObserver === 'undefined') {
      nodes.forEach(reveal);
      return;
    }

    // Assign stagger delays.
    nodes.forEach(function (n) {
      var kids = n.querySelectorAll('[data-kx-stagger]');
      kids.forEach(function (k, i) {
        k.style.transitionDelay = (0.1 + i * 0.13) + 's';
      });
    });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { reveal(e.target); io.unobserve(e.target); }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -6% 0px' });

    nodes.forEach(function (n) { io.observe(n); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
